import useCareerPaths from "@/hooks/useCareerPaths";
import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";
import Vector1 from "./Vector1.svg";
import Vector2 from "./Vector2.svg";

export default function ({ className = "py-5 py-md-6", tagline, EditableText, theme = "light" }) {
  const paths = useCareerPaths();
  const [path, setPath] = useState(paths[0]);

  return (
    <div className={cn(className, classes.CareerPaths)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2n:x0:z1" image={bg_1} floating={false} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x0:z0" image={bg_2} floating={false} className={classes.bg_2} />
      <Container fluid="xl">
        <Row>
          <Col xs={12}>
            <Buttons
              className="flex-wrap justify-content-center pt-3 pb-md-5"
              buttons={paths.map((p) => ({
                label: p.title,
                variant: "outline-cyan",
                active: p.id === path.id,
                onclick: (e) => {
                  e.preventDefault();
                  setPath(p);
                },
              }))}
            />
          </Col>
        </Row>
        <Row className="flex-md-row-reverse">
          <Col xs={12} md={6}>
            <div className={cn(classes.content, "py-5 py-md-0")}>
              <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
                <span dangerouslySetInnerHTML={{ __html: tagline }} />
              </Tagline>
              <h3 className="h2">{path.title}</h3>
              <div dangerouslySetInnerHTML={{ __html: path.description }} />
            </div>
          </Col>
          <Col xs={12} md={6} className="position-relative">
            <img src={Vector1} alt="" className={classes.vector_1} />
            <ParallaxHexagon translateY={[0, 20]} className={classes.img}>
              <img src={path.image} alt="" />
            </ParallaxHexagon>
            <img src={Vector2} alt="" className={classes.vector_2} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
